import SearchUtils from 'utils/search-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';
import DynamicRatesAPI from 'api/dynamic-rates';
import {Page, fetchCity, isMonthlyPage} from 'utils/page-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';
import AppRatingAPI from 'api/app-rating';

const getInitialState = async ({state, cookies, params: {slug}, route}) => {
    const cleanedSlug = slug.replace(/-parking$/, '');
    const pageType = Page.MID_FUNNEL;
    const isMonthly = isMonthlyPage(route);
    const [city, dynamicRates, page, appRating] = await Promise.all([
        fetchCity(state, cleanedSlug),
        DynamicRatesAPI.getRatesByCity(cleanedSlug),
        CMSUtils.getPageData({
            cookies,
            slug: cleanedSlug,
            customType: PRISMIC_CUSTOM_TYPE.CITY_MIDFUNNEL,
            pageType,
        }),
        AppRatingAPI.get(),
    ]);

    const {
        data: {timezone},
    } = city;

    const searchRequest = {
        ...searchRequestInitialState,
        pageType,
        ...SearchUtils.createTimeWindowParams(pageType, {}, timezone),
    };

    if (isMonthly) {
        searchRequest.monthly = isMonthly;
    }

    return {
        ...state,
        city,
        searchRequest,
        page,
        appRating: {...appRating, isPending: false},
        dynamicRates: {
            data: dynamicRates,
        },
    };
};

export default getInitialState;
